// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3j9jS","title":"BackImages_title__1wQc0","images":"BackImages_images__3oztM"};